"use client";

import { ArrowDown, ArrowUpRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function StartYourAssessment() {
  const {
    ref: contentRef,
    isVisible: contentVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: cardRef,
    isVisible: cardVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const projectMeta = [{
    label: "ASSET TYPE",
    value: "FRACTIONAL RESORT"
  }, {
    label: "LOCATION",
    value: "LOS CABOS, MX"
  }, {
    label: "STATUS",
    value: "EXIT COMPLETED"
  }, {
    label: "TIMELINE",
    value: "90 DAYS"
  }, {
    label: "COMPLIANCE",
    value: "PROFECO / SAT"
  }, {
    label: "RECOVERY",
    value: "100% LIBERATED"
  }];
  return <section data-section-id="4166" id="start-your-assessment" className="relative bg-background text-foreground overflow-hidden">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1660969/img/pb_sunset_beach_pool.png)]" />

      {}
      <div className="absolute inset-0" style={{
      background: "linear-gradient(90deg, hsl(220, 15%, 6%, 0.95) 0%, hsl(220, 15%, 6%, 0.85) 35%, hsl(220, 15%, 6%, 0.5) 65%, hsl(220, 15%, 6%, 0.2) 100%)"
    }} />

      {}
      <div className="absolute inset-0 opacity-[0.05] mix-blend-overlay pointer-events-none" style={{
      backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>\")"
    }} />

      {}
      <div className="absolute top-0 left-0 right-0 h-px bg-border/20" />

      {}
      <div className="absolute top-8 right-6 md:right-12 z-10 font-mono text-[11px] tracking-widest text-muted-foreground/60">
        LEDGER / 03
      </div>

      <div className="relative z-10 px-6 md:px-12 lg:px-16 py-24 md:py-32 lg:py-40">
        <div className="grid grid-cols-12 gap-6 lg:gap-8 max-w-[1440px] mx-auto">
          {}
          <div ref={contentRef} className={`col-span-12 lg:col-span-7 transition-all duration-1000 ease-out ${contentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            {}
            <div className="flex items-center gap-3 mb-10 md:mb-14">
              <span className="h-px w-10 bg-primary" />
              <span className="font-mono text-xs tracking-[0.25em] text-primary">
                03 — EXIT STRATEGY
              </span>
            </div>

            {}
            <h2 className="font-default font-bold uppercase leading-[0.85] tracking-[-0.04em] text-foreground mb-12 md:mb-16" style={{
            fontSize: "clamp(4rem, 10vw, 10rem)"
          }}>
              <span className="block text-white">SECURE /</span>
              <span className="block text-white">YOUR /</span>
              <span className="block font-serif italic font-light" style={{
              WebkitTextStroke: "1.5px hsl(38 75% 55%)",
              color: "white"
            }}>
                EXIT.
              </span>
            </h2>

            {}
            <p className="font-default text-white leading-relaxed mb-10 md:mb-12" style={{
            fontSize: "19px",
            maxWidth: "460px"
          }}>
              We provide a legally compliant, step-by-step exit process for timeshare and fractional owners. Emphasizing zero upfront costs and total transparency in transfer fee management.
            </p>

            {}
            <div className="flex flex-col sm:flex-row sm:items-center gap-6 sm:gap-8">
              <Link to="/ExitStrategyPage">
                <Button size="lg" className="h-14 px-8 bg-primary text-primary-foreground hover:bg-secondary hover:text-secondary-foreground font-mono text-xs tracking-[0.2em] uppercase rounded-md transition-colors duration-300" style={{
                boxShadow: "0 12px 40px -12px hsla(38, 75%, 55%, 0.4)"
              }}>
                  Get Your Assessment
                  <ArrowUpRight className="size-4" />
                </Button>
              </Link>

              <Link to="/ContactPage" className="group inline-flex items-center gap-3 font-mono text-xs tracking-[0.2em] uppercase text-foreground border-b border-foreground/30 pb-3 hover:border-primary hover:text-primary transition-colors duration-300">
                Legal Compliance PDF
                <ArrowDown className="size-3.5 group-hover:translate-y-0.5 transition-transform" />
              </Link>
            </div>
          </div>

          {}
          <div ref={cardRef} className={`col-span-12 lg:col-span-5 lg:pl-8 flex lg:items-center transition-all duration-1000 delay-200 ease-out ${cardVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="relative w-full rounded-md p-8 md:p-10 border border-border/20" style={{
            background: "hsla(220, 15%, 10%, 0.6)",
            backdropFilter: "blur(20px) saturate(150%)",
            WebkitBackdropFilter: "blur(20px) saturate(150%)",
            boxShadow: "0 32px 80px -16px hsla(0, 0%, 0%, 0.5)"
          }}>
              {}
              <div className="flex items-start justify-between mb-8 pb-6 border-b border-border/20 !text-[rgba(252,253,255,1)]">
                <div>
                  <div className="font-mono text-[10px] tracking-[0.25em] text-white mb-2">
                    VERIFIED CASE
                  </div>
                  <div className="font-mono text-[10px] tracking-[0.2em] text-white">
                    REF / IMI-0247
                  </div>
                </div>
                <div className="size-2 bg-primary" style={{
                boxShadow: "0 0 12px hsl(38 75% 55%)"
              }} />
              </div>

              {}
              <div className="grid grid-cols-2 gap-x-6 gap-y-6">
                {projectMeta.map((item, i) => <div data-index={i} key={i} className="flex flex-col gap-2">
                    <span className="font-mono text-[10px] tracking-[0.2em] text-white/70 uppercase">
                      {item.label}
                    </span>
                    <span className="font-mono text-xs tracking-wider text-white uppercase">
                      {item.value}
                    </span>
                  </div>)}
              </div>

              {}
              <div className="mt-10 pt-6 border-t border-border/20 flex items-center justify-between">
                <span className="font-mono text-[10px] tracking-[0.25em] text-white/60 uppercase">
                  PROFECO Compliant
                </span>
                <Link to="/RealEstatePage" className="inline-flex items-center gap-2 font-mono text-[10px] tracking-[0.25em] uppercase text-primary hover:text-white transition-colors">
                  Success Stories
                  <ArrowUpRight className="size-3" />
                </Link>
              </div>

              {}
              <div className="absolute top-0 left-0 w-4 h-px bg-primary" />
              <div className="absolute top-0 left-0 h-4 w-px bg-primary" />
              <div className="absolute bottom-0 right-0 w-4 h-px bg-primary" />
              <div className="absolute bottom-0 right-0 h-4 w-px bg-primary" />
            </div>
          </div>
        </div>

        {}
        <div className="mt-20 md:mt-28 pt-8 border-t border-border/20 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 max-w-[1440px] mx-auto">
          <span className="font-mono text-[10px] tracking-[0.25em] text-white/50 uppercase">
            IMI ELITE / Asset Management Division
          </span>
          <span className="font-mono text-[10px] tracking-[0.25em] text-white/50 uppercase">29 Years Resort Expertise — SAT Registered</span>
        </div>
      </div>
    </section>;
}